// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/restaurant/diner_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_booking_booking_participant } from "../booking_participant_pb";
import { file_proto_model_booking_restaurant_seating_preferences } from "./seating_preferences_pb";
import { file_proto_model_booking_restaurant_celebration_details } from "./celebration_details_pb";
import { file_proto_model_booking_shared_loyalty_membership } from "../shared/loyalty_membership_pb";
import { file_proto_model_feature_restaurant_food_preferences } from "../../feature/restaurant/food_preferences_pb";

/**
 * Describes the file proto/model/booking/restaurant/diner_info.proto.
 */
export const file_proto_model_booking_restaurant_diner_info = /*@__PURE__*/
  fileDesc("Ci9wcm90by9tb2RlbC9ib29raW5nL3Jlc3RhdXJhbnQvZGluZXJfaW5mby5wcm90bxIGY2FybWVuIsEDCglEaW5lckluZm8SLwoLcGFydGljaXBhbnQYASABKAsyGi5jYXJtZW4uQm9va2luZ1BhcnRpY2lwYW50EiUKCmRpbmVyX3R5cGUYAiABKA4yES5jYXJtZW4uRGluZXJUeXBlEjEKEGZvb2RfcHJlZmVyZW5jZXMYAyABKAsyFy5jYXJtZW4uRm9vZFByZWZlcmVuY2VzEjcKE3NlYXRpbmdfcHJlZmVyZW5jZXMYBCABKAsyGi5jYXJtZW4uU2VhdGluZ1ByZWZlcmVuY2VzEjcKE2NlbGVicmF0aW9uX2RldGFpbHMYBSABKAsyGi5jYXJtZW4uQ2VsZWJyYXRpb25EZXRhaWxzEjYKE2xveWFsdHlfbWVtYmVyc2hpcHMYBiADKAsyGS5jYXJtZW4uTG95YWx0eU1lbWJlcnNoaXASRQoTcHJvdmlkZXJfZGluZXJfZGF0YRgHIAMoCzIoLmNhcm1lbi5EaW5lckluZm8uUHJvdmlkZXJEaW5lckRhdGFFbnRyeRo4ChZQcm92aWRlckRpbmVyRGF0YUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEqlQEKCURpbmVyVHlwZRIaChZESU5FUl9UWVBFX1VOU1BFQ0lGSUVEEAASFAoQRElORVJfVFlQRV9BRFVMVBABEhQKEERJTkVSX1RZUEVfQ0hJTEQQAhIVChFESU5FUl9UWVBFX0lORkFOVBADEhUKEURJTkVSX1RZUEVfU0VOSU9SEAQSEgoORElORVJfVFlQRV9WSVAQBUIwWi5naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9ib29raW5nYgZwcm90bzM", [file_proto_model_booking_booking_participant, file_proto_model_booking_restaurant_seating_preferences, file_proto_model_booking_restaurant_celebration_details, file_proto_model_booking_shared_loyalty_membership, file_proto_model_feature_restaurant_food_preferences]);

/**
 * Describes the message carmen.DinerInfo.
 * Use `create(DinerInfoSchema)` to create a new message.
 */
export const DinerInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_restaurant_diner_info, 0);

/**
 * Describes the enum carmen.DinerType.
 */
export const DinerTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_restaurant_diner_info, 0);

/**
 * @generated from enum carmen.DinerType
 */
export const DinerType = /*@__PURE__*/
  tsEnum(DinerTypeSchema);

